var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-actions",
    {
      attrs: {
        "no-actions": "",
        "show-loading": _vm.loading,
        title: _vm.$t("Controle de documentos"),
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "mb-2" },
        [
          _c(
            "b-col",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("e-button", {
                attrs: {
                  text: _vm.$t("Adicionar documento"),
                  variant: "primary",
                },
                on: { click: _vm.onAddPermitLicense },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-table", {
                ref: "permit-licenses-table",
                staticClass: "table-responsive bordered",
                attrs: {
                  id: "permit-licenses-table",
                  responsive: "",
                  striped: "",
                  "show-empty": "",
                  "tbody-tr-class": _vm.rowClass,
                  items: _vm.paginatedPermitLicenses,
                  fields: _vm.fields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(actions)",
                    fn: function (row) {
                      return [
                        !row.item.isLocal
                          ? _c("e-grid-actions", {
                              attrs: {
                                "show-delete": true,
                                "show-update": false,
                                buttons: [
                                  {
                                    icon: "download",
                                    variant: "primary",
                                    title: _vm.$t("Baixar arquivo"),
                                    event: "download-file",
                                  },
                                ],
                              },
                              on: {
                                delete: function ($event) {
                                  return _vm.onDeletePermitLicense(row.item)
                                },
                                "download-file": function ($event) {
                                  return _vm.onDownloadFile(row)
                                },
                              },
                            })
                          : _c("e-grid-actions", {
                              attrs: {
                                "show-delete": true,
                                "show-update": false,
                                buttons: [],
                              },
                              on: {
                                delete: function ($event) {
                                  return _vm.onDeleteLocalPermitLicense(
                                    row.item
                                  )
                                },
                              },
                            }),
                      ]
                    },
                  },
                  {
                    key: "cell(permitLicenseType)",
                    fn: function (row) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getPermitLicenseType(
                                row.item.permitLicenseType
                              )
                            ) +
                            " "
                        ),
                        row.item.observation
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "text-primary cursor-pointer ml-50",
                                attrs: {
                                  id:
                                    "permit-license-observation-" +
                                    (row.item.id || row.item.localId),
                                  tabindex: "0",
                                },
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "InfoIcon" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        row.item.observation
                          ? _c("b-tooltip", {
                              attrs: {
                                target:
                                  "permit-license-observation-" +
                                  (row.item.id || row.item.localId),
                                title: row.item.observation,
                                placement: "top",
                                triggers: "hover click",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(dueDate)",
                    fn: function (row) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm._f("date")(row.item.dueDate)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("e-pagination-summary", {
                        attrs: {
                          "current-page": _vm.paging.currentPage,
                          "per-page": _vm.paging.pageSize,
                          total: _vm.paging.rowCount,
                          "total-on-page": _vm.paging.rowsInCurrentPage,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("b-pagination", {
                        attrs: {
                          align: "right",
                          "total-rows": _vm.paging.rowCount,
                          "per-page": _vm.paging.pageSize,
                          "aria-controls": "product-table",
                        },
                        model: {
                          value: _vm.paging.currentPage,
                          callback: function ($$v) {
                            _vm.$set(_vm.paging, "currentPage", $$v)
                          },
                          expression: "paging.currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("e-color-subtitled", {
                        attrs: {
                          colors: [
                            {
                              backgroundColor: "table-danger",
                              title: _vm.$t("Vencido"),
                            },
                          ],
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("permit-licenses-sidebar", {
            ref: "permitLicensesSidebar",
            attrs: { "is-edition": _vm.isEdition },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }